import axios from "axios";

import {
  GET_FamilyMem,
  RESET_FamilyMem,
  LOADING
} from "../actionTypes";
import { DEV_FM_APIS_URL, AWS_SERVER_APIS} from "configurations";
import { adminToken } from "../../helper";

const { SET_TRUE, SET_FALSE } = LOADING;

export const get = (elder_id) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminToken()
      .then(token =>
        axios.get(
          `${AWS_SERVER_APIS}/elder-family?elder_id=${elder_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch({ type: GET_FamilyMem, payload: res.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const add = ({ name = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminToken()
      .then(token =>
        axios.post(
          `${AWS_SERVER_APIS}/elder-family`,
          {
            "channel_name": `${name}`
          },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const update = ({ id = "", name = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminToken()
      .then(token =>
        axios.put(
          `${AWS_SERVER_APIS}/elder-family`,
          {
            "id":id,
            "channel_name": `${name}`
        },
          
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const deletedata = ({ id = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminToken()
      .then(token =>
        axios.delete(
        `${AWS_SERVER_APIS}/elder-family/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const reset = () => dispatch => dispatch({ type: RESET_FamilyMem });
